import { render, staticRenderFns } from "./CampaignTemplates.vue?vue&type=template&id=88ad2488&"
import script from "./CampaignTemplates.vue?vue&type=script&lang=js&"
export * from "./CampaignTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports